import React, { useEffect } from 'react';
import { Helmet } from 'react-helmet';

import { withProviders } from 'src/common/hocs/with-providers';
import { LEGAL_LINKS } from 'src/config';

import './report.css';

const Report = () => {
  useEffect(() => {
    // Content reports are handled by the support team through Zendesk.
    window.location.replace(LEGAL_LINKS.reportForm);
  }, []);

  return (
    <div className="card report">
      <Helmet>
        <meta name="robots" content="noindex" />
      </Helmet>
      <div style={{ textAlign: 'center' }}>
        Redirecting you to our support form.{' '}
        <a href={LEGAL_LINKS.reportForm}>Continue</a>
      </div>
    </div>
  );
};

export default withProviders({ design: 'v1' })(Report);
